const getAllDocumentList = async ({ token, caseNo, caseID }) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/get_all_document_list?caseId=${caseID}&caseNo=${caseNo}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getAllDocumentList;
